import { createReducer, on } from '@ngrx/store';
import * as fromSubscriptionsActions from '../actions/subscriptions.actions';
import { Subscription } from 'src/app/models/subscription.model';

export interface SubscriptionsState {
  data: Subscription[];
  loaded: boolean;
  loading: boolean;
  error: string;
  selectedTabIndex: number;
}

export const initialState: SubscriptionsState = {
  data: undefined as any,
  loaded: false,
  loading: false,
  error: '',
  selectedTabIndex: 0
};

export const subscriptionsReducer = createReducer(
  initialState,
  on(fromSubscriptionsActions.LoadSubscriptionsAction, (state) => ({
    ...state,
    loading: true
  })),
  on(
    fromSubscriptionsActions.LoadSubscriptionsSuccessAction,
    (state, { data }) => ({
      ...state,
      data,
      loaded: true,
      loading: false
    })
  ),
  on(
    fromSubscriptionsActions.LoadSubscriptionsFailAction,
    (state, { error }) => ({
      ...state,
      error: error.message
    })
  ),
  on(fromSubscriptionsActions.SetTabIndexProfileAction, (state, { index }) => ({
    ...state,
    selectedTabIndex: index
  }))
);
